// import axios from 'axios';
// import logger from "./logService";
import axios from 'axios';
// import { toast } from "react-toastify";

axios.interceptors.response.use(null, error => {
    const expectedError = error.respons && error.response.status >= 500 && error.response.status <500;

    if(!expectedError) {
        // logger.log(error);
        // toast.error("An unexpected error has occurred")
    }

    return Promise.reject(error);
})

function setJwt(jwt) {
    //sets JWT from aut to avoid bi-directional 
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    setJwt
}